import { gql } from "@apollo/client";

export default gql`
  query getProfileReviewsQuery($profileId: Int!, $after: String) {
    assessmentDeliveries(
      targetId: $profileId
      first: 5
      after: $after
      state_In: [delivered, admins_and_mgrs_only]
      orderBy: "-submitted_datetime"
    ) {
      edges {
        node {
          id
          deliveryDatetime
          lastSubmissionDatetime
          target {
            id
            name
            email
            firstName
            avatar
          }
          complianceProgram {
            id
            title
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
